import type { ReactElement } from 'react';
import styles from './KpiCard.module.css';

interface Props {
  label: string;
  wrapValue?: boolean;
  value: number | string;
  accent?: 'default' | 'red' | 'amber' | 'green';
  /** An inline SVG (KpiIcon), never an emoji string (R14). */
  icon?: ReactElement;
  onClick?: () => void;
}

export function KpiCard({ label, value, accent = 'default', icon, onClick, wrapValue }: Props) {
  const cardClass = `${styles.card} ${styles[accent]} ${onClick ? styles.clickable : ''}`;
  return (
    <div className={cardClass} onClick={onClick}>
      {icon && <span className={styles.icon}>{icon}</span>}
      <div className={`${styles.value} ${wrapValue ? styles.wrapValue : ''}`}>
        {wrapValue && typeof value === 'string'
          ? value.split(',').map((group, index, groups) => (
              <span key={index}>
                <span className={styles.valueGroup}>
                  {group}
                  {index < groups.length - 1 ? ',' : ''}
                </span>
                {index < groups.length - 1 && <wbr />}
              </span>
            ))
          : value}
      </div>
      <div className={styles.label}>{label}</div>
    </div>
  );
}
